export const translations = {
  Autoplay: 'Autoplay',
  'Autoplay site sounds': 'Autoplay site sounds',
  'Start new game in explore mode.': 'Нæуæг æсгарун гъазт райдайæн.',
  'Image selection': 'Сорæт æвзарун',
  'Letters selection': 'Дамугътæ æвзарун',
  'Tell again': 'Tell again',
  'Report an issue': 'Report an issue',
  Contribute: 'Contribute',
  'Game skipped. Starting the next game in {seconds} seconds.': 'Game skipped. Starting the next game in {seconds} seconds.',
  'Amazing. New game will start in {seconds} seconds.': 'Amazing. New game will start in {seconds} seconds.',
  Skip: 'Фæццох кæнун',
  'Warning: this is alpha version of the app. Please be ready to lose you progress in explore mode once. Sorry for inconvenience.': 'Кит: алфа верси. Уотæ гæнæн ес æма дæ прогресс байсафдзæнæй еу бон. Ниххатир мин йæ кæнæ.',
  Help: 'Агъаз',
  Leave: 'Рандæ ун',
  Contest: 'Ерис',
  'Find rival': 'FIXME:',
  'Start train': 'Ахур райдайун',
  Train: 'Ахур',
  Amazing: 'Хъæбæр хуарз',
  'Amazing. New round will start in {seconds} seconds.': 'Хъæбæр хуарз. Нæуæг раунд райдайдзæнæй {seconds} секунди фæстæ.',
  'Well, but not enough. Try again in {seconds} seconds.': 'Бæззуй, фал фагæ нæ ей. Еу хат ма бафæлварæ {seconds} секунди фæстæ.',
  'Very well. New round will start in {seconds} seconds.': 'Xуарз æй. Нæуæг раунд райдайдзæнæй {seconds} секунди фæстæ.',
  'Very well': 'Хуарз',
  'Well done.': 'Бæззуй.',
  'So bad. You can do better!': 'Лæгъуз. Дæ бон хуæздæр æй!',
  Explore: 'Æсгарун',
  'What?': 'Куд?',
  'You won!': 'Рамбулдтай!',
  'Solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Исихалæ {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} æма райдайдзæнæ {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',
  'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',

  // levels
  Simple: 'Еувазæг',
  Normal: 'Уаггин',
  Hard: 'Гъесгун'
}
